const STORAGE_KEY = 'callDebug';

/** В сборке панель включается `?debug=1` и держится до закрытия вкладки — переживает редиректы, теряющие query. */
export function isCallDebugEnabled(): boolean {
  if (!import.meta.env.PROD) return true;

  try {
    const flag = new URLSearchParams(window.location.search).get('debug');
    if (flag === '1') sessionStorage.setItem(STORAGE_KEY, '1');
    if (flag === '0') sessionStorage.removeItem(STORAGE_KEY);
    return sessionStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    // Safari в приватном режиме может запретить storage.
    return false;
  }
}
